module.exports = __webpack_public_path__ + "img/star_blaze.23ad3bd5.png";